import React from 'react';
import theme, {
  TMaterialStyleItem,
  TMaterialStyles,
  TShadow,
} from '../../theme';
import { ButtonBase } from '@mui/material';
import TypographyWithShadow from '../Typography/TypographyWithShadow';

interface IButtonOutlined extends React.PropsWithChildren {
  sx?: TMaterialStyleItem;
  onClick?: () => void;
  disabled?: boolean;
  shadowType?: TShadow;
  fontSize?: number;
}

export const ButtonOutlined: React.FC<IButtonOutlined> = ({
  children,
  sx,
  onClick,
  disabled,
  shadowType,
  fontSize = 15,
}) => {
  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      sx={[
        materialStyles.button,
        shadowType === 'DARK' ? materialStyles.buttonWithDarkShadow : null,
        shadowType === 'LIGHT' ? materialStyles.buttonWithLightShadow : null,
        disabled ? materialStyles.buttonDisabled : null,
        sx || null,
      ]}
    >
      <TypographyWithShadow
        sx={{ ...materialStyles.text, fontSize }}
        shadowType={shadowType}
      >
        {children}
      </TypographyWithShadow>
    </ButtonBase>
  );
};

const materialStyles: TMaterialStyles = {
  button: {
    border: '3px solid #FFFFFF',
    borderRadius: '100px',
    py: '8px',
    px: '16px',
    minWidth: '90px',
  },
  buttonDisabled: {
    backgroundColor: theme.palette.grey[300],
  },
  buttonWithDarkShadow: {
    boxShadow: `0px 2px 0px ${theme.palette.secondary.main}`,
  },
  buttonWithLightShadow: {
    boxShadow: `0px 2px 0px ${theme.palette.primary.main}`,
  },
  text: {
    fontFamily: 'Rubber Duck !important',
    fontSize: '15px',
    lineHeight: '18px',
  },
};
